import Employee from '../../../../admin/employee';

export default {
  name: 'negotiatedBy',
  components: { Employee },
  props: { leId: String, editMode: Boolean, wfHeaderId: Number },
  data() {
    return {
      showEmpModal: false,
      loader: false,
      negotiateIndex: null,
      negotiatedList: [
        {
          primary_flag: false,
          employee_name: null,
          remarks: null,
          employee_id: null
        }
      ],
      negotiatedFeilds: [
        {
          key: 'primary_flag',
          label: 'Primary'
        },

        {
          key: 'employee_name',
          label: 'Name'
        },
        {
          key: 'remarks'
        },
        {
          key: 'add'
        },
        {
          key: 'remove'
        }
      ]
    };
  },
  mounted() {
    if (this.wfHeaderId) {
      this.getNegotiatedList(this.wfHeaderId);
    }
    this.eventBus.$on('negotiatedBy', wfHeaderId => {
      if (wfHeaderId) {
        this.getNegotiatedList(wfHeaderId);
      }
    });
  },
  methods: {
    getNegotiatedList(wfHeaderId) {
      this.loader = true;
      const payload = {
        tabType: 'negotiated-by',
        wfHeaderId: wfHeaderId
      };
      this.$store
        .dispatch('intWorkflow/getWfTabsDetails', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200 && response.data.data.length > 0) {
            this.negotiatedList = response.data.data;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    addNewRow() {
      if (this.editMode) {
        this.negotiatedList.push({
          primary_flag: null,
          employee_name: null,
          remarks: null,
          employee_id: null
        });
      }
    },
    removeRow(index) {
      this.negotiatedList.splice(index, 1);
    },
    showHideEmpModal(flag, index) {
      this.negotiateIndex = index;
      this.showEmpModal = flag;
    },
    employeeDetails(emp) {
      this.negotiatedList[this.negotiateIndex].employee_name = emp.name;
      this.negotiatedList[this.negotiateIndex].employee_id = emp.employee_id;
      this.showEmpModal = false;
    },
    rowSelected() {}
  },
  beforeDestroy() {
    this.eventBus.$off('negotiatedBy');
  }
};
